import {
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE,
  SET_SUMMIT,
  GET_DATA_CUSTOMER,
  GET_DATA_CUSTOMER_DETAILS,
  SET_DATA_NOTIFICATION_REMARK,
  CLEAR_ALL_DATA,
  GET_DATA_EVENT,
  _GET_ALL_DETIALS
} from "./action";

const initialState = {
  loading: false,
  dataStore: false,
  serviceAndMeterCat: [],
  customerData: [],
  eventData:[],
  NotificationRemark:[],
  returnData:[],
  error: "",
};

const notificatinReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATA_REQUEST:
      return { ...state, loading: true };
    case FETCH_DATA_SUCCESS:
      return { loading: false, serviceAndMeterCat: action.payload, error: "" };
    case FETCH_DATA_FAILURE:
      return { loading: false, data: [], error: action.error };
    case SET_SUMMIT:
      return { dataStore: true, data: [], error: action.error };
    case GET_DATA_CUSTOMER:
      return { ...state, customerData: action.payload, loading: true };
    case GET_DATA_CUSTOMER_DETAILS:
      return { ...state, customerTableData: action.payload, loading: true };
    case SET_DATA_NOTIFICATION_REMARK:
      return { ...state, NotificationRemark: action.payload, loading: true };
      case GET_DATA_EVENT:
        return   { ...state, eventData:action.payload , loading: true };
      case CLEAR_ALL_DATA:
        return {...state, customerData:undefined,customerTableData:undefined,NotificationRemark:undefined}
      case _GET_ALL_DETIALS:
        return {...state, returnData:action.payload, loading: true}
        default:
      return state;
  }
};

export default notificatinReducer;
